import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { handleError } from './common';
import { initVerificationAction, submitCode } from './verification';

/*
	Sync functions
*/
function initAuthenticatorAction(data) {
	return {
		type: 'INIT_AUTHENTICATOR',
		data: data
	}
}

export function saveAuthenticatorAction(data) {
	return {
		type: 'SAVE_AUTHENTICATOR',
		data: data
	}
}

/*
	Async functions
*/
export function initAuthenticator() {
	return dispatch => {
		fetch('/api/account/authenticator/init', {credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleInitAuthenticator(dispatch, data))
	}
}

export function saveAuthenticator(code) {
	return dispatch => {
		fetch('/api/account/authenticator/save', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				code: code
			})
		})
			.then(response => response.json())
			.then(data => handleSaveAuthenticator(dispatch, data))
	}
}

/*
 Helper functions
*/
function handleInitAuthenticator(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(initAuthenticatorAction(data));
	switch (data.next_action.action_type) {
		case ACTION_TYPE.APPLY_MOBILE:
			browserHistory.push('/security/authenticator/no_mobile');
			break;
		case ACTION_TYPE.APPLY_EMAIL:
			browserHistory.push('/security/authenticator/no_email');
			break;
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/authenticator/2-step-verification');
			break;
		case ACTION_TYPE.SAVE_AUTHENTICATOR:
			dispatch(saveAuthenticatorAction(data));
			browserHistory.push('/security/authenticator/save');
			break;
		case ACTION_TYPE.REVOKE_AUTHENTICATOR:
			browserHistory.push('/security/authenticator/done_revoke');
			break;
		default:
			break;
	}
}

function handleSaveAuthenticator(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(saveAuthenticatorAction(data));
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.DONE) {
		browserHistory.push('/security/authenticator/done_save');
	}
}



// WEBPACK FOOTER //
// ./app/actions/authenticator.js